import { memo, ReactNode, useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { ScrollbarRef,Scrollbars } from "@tecorien/mimic-v2";
import { Navbar } from "./Navbar";

import styles from "./style.module.scss";

export type AuthLayoutProps = {
  children?: ReactNode | ReactNode[],
  hideMenu?: boolean
  hideProfile?: boolean
  rootLink?: string
}

export const SiteLayout = memo<AuthLayoutProps>(({ children, hideMenu, hideProfile, rootLink }) => {
  const scrollRef = useRef<ScrollbarRef>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.style.setProperty("--background-color", "white");
  }, []);

  useEffect(() => {
    scrollRef?.current?.osInstance()
      ?.elements()
      .viewport
      ?.scroll
      ?.({ top: 0, left: 0 });
  }, [ scrollRef, pathname ]);

  return (
    <div className={styles.root}>
      <Navbar
        className={styles.navbar}
        hideMenu={hideMenu}
        hideProfile={hideProfile}
        rootLink={rootLink}
      />
      <Scrollbars
        className={styles.scrollbar}
        ref={scrollRef}
      >
        {children}
      </Scrollbars>
    </div>
  );
});

export default SiteLayout;